import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import styled, { css } from 'styled-components'
import searchGraySemiDark from 'assets/icons/search-gray-semi-dark.svg'

interface IUseStyles {
  withLogo: boolean
  size?: 'sm'
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootTextField: {
      width: '100%',
      padding: '20px 0 0',
      '& .MuiSelect-icon': {
        right: 10,
      },
      '& .MuiInputBase-root': {
        marginTop: 0,
        borderRadius: 30,
        backgroundColor: theme.colors.greySemiLight,
        padding: 0,
        boxSizing: 'border-box',
        height: ({ size }: IUseStyles) => (size === 'sm' ? 32 : 40),

        [theme.breakpoints.up(1024)]: {
          height: ({ size }: IUseStyles) => (size === 'sm' ? 36 : 48),
        },
      },
      '& .MuiAutocomplete-endAdornment': {
        right: 16,
      },
      '& .MuiInput-underline:after': {
        display: 'none',
      },
      '& .MuiInput-underline:before': {
        display: 'none',
      },
      '& .MuiAutocomplete-input': {
        padding: ({ withLogo }: IUseStyles) => (withLogo ? '0 30px 0 56px !important' : '0 30px 0 24px !important'),
        height: '100%',
      },
      '& .MuiInputLabel-root': {
        transform: 'translate(16px, 32px)',
        maxWidth: 'calc(100% - 16px)',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        color: theme.colors.greySemiDark,

        '&.Mui-disabled': {
          color: `${theme.colors.grey}`,
        },

        [theme.breakpoints.up(1024)]: {
          maxWidth: 'calc(100% - 24px)',
          transform: 'translate(24px, 32px)',
        },

        [theme.breakpoints.down(1023)]: {
          fontSize: 12,
        },
      },
      '& .MuiInputLabel-shrink': {
        transform: 'translate(16px, 0)!important',
        fontSize: 12,

        [theme.breakpoints.up(1024)]: {
          transform: 'translate(24px, 0)!important',
        },
      },
      '& .MuiFormHelperText-root': {
        minHeight: 20,
        fontFamily: theme.fonts.inter,
        color: theme.colors.red,
        letterSpacing: 'normal',
        fontSize: 12,
        lineHeight: 1.5,
        maxWidth: '100%',
        paddingLeft: 16,
        marginTop: 0,

        [theme.breakpoints.up(1024)]: {
          paddingLeft: 24,
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        visibility: 'hidden',
      },
      '& .MuiAutocomplete-popupIndicator': {
        '&.Mui-disabled': {
          color: `${theme.colors.grey}`,
        },
      },
    },
    logo: {
      position: 'absolute',
      top: 28,
      left: 24,
      zIndex: 1,

      [theme.breakpoints.up(1024)]: {
        top: 32,
      },
    },
  })
)

export const InputWrap = styled.div<{ startAdornment?: boolean }>`
  ${({ theme, startAdornment }) => css`
    position: relative;
    width: 100%;

    ${startAdornment &&
    css`
      input.MuiAutocomplete-input {
        background: url(${searchGraySemiDark}) no-repeat 16px center;
        padding-left: 40px !important;
      }
    `}

    .active {
      position: absolute;
      top: 32px;
      right: 40px;
      color: ${theme.labels.openCabinet};
      display: inline-flex;
      align-items: center;

      svg {
        fill: ${theme.labels.openCabinet};
        margin-right: 4px;
      }
    }
  `}
`

export const StyledOption = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;

    .active {
      position: absolute;
      top: 0;
      right: 16px;
      color: ${theme.labels.openCabinet};
      display: inline-flex;
      align-items: center;

      svg {
        fill: ${theme.labels.openCabinet};
        margin-right: 4px;
      }
    }
  `}
`

export const IconSearch = styled.div`
  ${({ theme }) => css`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${theme.colors.green};
    margin-top: 4px;

    ${theme.breakpoints.up(1024)} {
      margin-top: 14px;
    }
  `}
`
